import DueDate from '../PregnancyPage/DueDate';
import { GridWrapper } from '../StoreHomePage/BannersGrid/styled';
import Testimonials from '../StoreHomePage/Testimonials';
import TopCarousel from '../StoreHomePage/TopCarousel';
import ArticlesAndVideos from './ArticlesAndVideos';
import CostCalculator from './BabyCostCalculator/CostCalculator';
import CommunityDiscussions from './CommunityDiscussions.jsx/CommunityDiscussions';
import HeadingSEO from './HeadingSEO';
import OvulationTracker from './OvulationTracker/OvulationTracker';
import ParentingGeneralGrid from './ParentingGeneralGrid/ParentingGeneralGrid';
import ParentingGrowthTracker from './ParentingGrowthTracker/ParentingGrowthTracker';
import ParentingHelpfulTools from './ParentingHelpfulTools/ParentingHelpfulTools';
import ParentingTrustStrip from './ParentingTrustStrip/ParentingTrustStrip';
import ParentingTopics from './PrentingTopics/ParentingTopics';
import TopSeoCarousel from './TopCarouselSEO/TopSeoCarousel';
import TrendingTopics from './TrendingTopics';
import RecentAddedArticles from './RecentAddedArticles/RecentlyAddedArticlesCover';
import { getPublicUrl } from '../../appconfig';
import GrowthTracker from '../PregnancyPage/GrowthTracker';
import Loader from '../Loader';
import { useState } from 'react';

export default function ParentingGeneralItems(props) {
  const {
    parentingPageData,
    isStagePage,
    stage,
    tagId,
    questionData,
    recentlyAskedQues,
    babyGrowthData,
  } = props;
  const [loader, showLoader] = useState(false);
  const [currentWeek, setCurrentWeek] = useState(18);
  return (
    <>
      {parentingPageData?.data?.items?.map((element) => {
        switch (element?.itemType) {
          case 'MULTIPLE_ITEMS':
            switch (element?.viewType) {
              case 'CAROUSEL':
                return element?.items?.[0]?.itemSize == 'LARGE' ? (
                  <>
                    <TopCarousel
                      banner={element}
                      type={element?.viewType}
                      key={element?.itemName}
                      noMobileCategory={true}
                      isParentingPage={true}
                    />
                    <HeadingSEO />
                  </>
                ) : (
                  <Testimonials
                    banner={element}
                    key={element?.itemName}
                    isParentingPage={true}
                  />
                );
            }
          case 'BANNER_WITH_TEXT':
            return <TopSeoCarousel isParentingPage={true} data={element} />;
          case 'BABY_COST_CALCULATOR':
            return (
              <GridWrapper>
                <CostCalculator
                  data={element}
                  buttonCTA={'Calculate'}
                  Deeplink={`${getPublicUrl()}/store/babyexpendeture`}
                  color={'#fef7d9'}
                />
              </GridWrapper>
            );
          case 'CALCULATE_OVULATION_DAY':
            return <OvulationTracker data={element} />;
          case 'PARENTING_TRUST_FACTORS':
            return <ParentingTrustStrip />;

          case 'STAGE_TAGS_INFO':
            return <ParentingGeneralGrid data={element} />;
          case 'WEB_STAGE_TOOLS':
            return <ParentingHelpfulTools data={element} stage={isStagePage} />;
          case 'PARENTING_STAGE_TOPICS':
            return <TrendingTopics data={element} isStagePage={isStagePage} />;
          case 'MOST_VIEWED_WEB_CONTENT':
            return (
              <ArticlesAndVideos
                showLoader={showLoader}
                articleVideoData={element}
                stage={stage}
              />
            );
          case 'CALCULATE_DUE_DATE':
            return (
              <GridWrapper>
                <DueDate setCurrentWeek={setCurrentWeek} />
              </GridWrapper>
            );
          case 'PARENTING_WEB_FEED':
            return (
              <CommunityDiscussions
                questionData={questionData}
                recentlyAskedQues={recentlyAskedQues}
                showLoader={showLoader}
                filterData={element}
                tagId={tagId}
                stage={isStagePage}
              />
            );
          case 'WEB_GROWTH_TRACKER':
            return element?.viewType == 'LINEAR' ? (
              <GrowthTracker
                currentWeek={currentWeek}
                setCurrentWeek={setCurrentWeek}
                babyGrowthData={babyGrowthData}
                margin={'40px 0'}
                mediamargin={'20px'}
              />
            ) : (
              <ParentingGrowthTracker data={element} />
            );
          case 'PARENTING_POPULAR_TOPICS':
            return <ParentingTopics data={element} stage={isStagePage} />;
          case 'RECENTLY_ADDED_ARTICLE':
            return (
              <RecentAddedArticles
                recentArticles={element?.items}
                heading={element?.heading}
                subHeading={element?.subHeading}
              />
            );
        }
      })}
      {loader && <Loader />}
    </>
  );
}
